import { Activity, StudyEntityType } from '@faro/study-designer-model';
import { createStudyEntityHookFactory } from '../createStudyEntityHookFactory';
import { activityClient, ActivityPathParameters } from './ActivityClient';

const factory = createStudyEntityHookFactory<Activity, ActivityPathParameters>(StudyEntityType.Activity);
export const useActivities = factory.list(activityClient.list);
export const useActivityClone = factory.mutate(activityClient.clone);
export const useActivityConfigurationUpdate = factory.mutate(activityClient.assignConfig);
export const useActivityClearTimepoints = factory.mutate(activityClient.removeTimepoints);
